//export const DOWNLOAD_URL = `http://localhost/download/index.php`;
export const DOWNLOAD_URL = `https://download.monitend.com`


export const API_URL = `https://api.monitend.com/`;
//export const API_URL = `http://localhost:8888/`;
//export const API_URL = `http://api.monitend.monitend.test.dev.pharmainsights.se/`;
